<main>
  <section class="report__disclaimer my-5">
    <div class="container">
      <form [formGroup]="reportDetailsForm" (submit)="submitReport()">
        <div class="row">
          <div class="card bg-white shadow border-0 col-12">
            <div class="row  card-body">
              <div class="col-12">
                <h3 class="border border-top-0 border-left-0 border-right-0 pb-3 font-weight-bold mb-4">
                  Test Drive Video
                </h3>
              </div>
              <div class="col-md-6 mb-3">
                <div class="form-group">
                  <label>Test drive Video id</label>
                  <input type="text" name="title" formControlName="test_drive_video" class="credential3__input form-control"
                    placeholder="Video id">
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="card bg-white shadow border-0 my-5 col-12">
            <div class="row card-body">
              <div class="col-12">
                <h3 class="border border-top-0 border-left-0 border-right-0 pb-3 font-weight-bold mb-4">
                  History Reports
                </h3>
              </div>
              <div class="col-md-6 mb-3 d-flex align-items-center">
                <div class="form-group">
                  <label>Document</label>
                  <input type="file" 
                    class="credential3__input form-control" 
                    formControlName="history_file"
                    (change)="getFile($event)"
                  >
                </div>
              </div>
              <div class="col-md-6" *ngIf="allData && allData['history_file']">
                <a [href]="env+allData['history_file']" target="_blank">
                  {{allData['history_file']}}
                </a>
              </div>
              <div class="col-md-12 mb-3">
                <div class="form-group">
                  <label>Description</label>
                  <textarea 
                    name="" 
                    id=""
                    rows="2" 
                    class="report__information form-control"
                    formControlName="history_comment" 
                    [class.is-invalid]="isSubmitted && historyControls['history_comment'].errors"
                  >
                  </textarea>
                  <div class="invalid-feedback">
                    <p>Description cannot be blank.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="card bg-white shadow border-0 col-12">
            <div class="row card-body">
              <div class="col-12">
                <h3 class="border border-top-0 border-left-0 border-right-0 pb-3 font-weight-bold mb-4">
                  Purchase Full computer report
                </h3>
              </div>
              <div class="col-md-6 mb-3">
                <div class="form-group">
                  <label>Document</label>
                  <input type="file" class="credential3__input form-control" formControlName="computer_report_file"
                    [class.is-invalid]="isSubmitted && historyControls['computer_report_file'].errors"
                    (change)="getComputerFile($event)">
                  <div class="invalid-feedback">
                    <p>File cannot be blank.</p>
                  </div>
                </div>
              </div>
              <div class="col-md-6" *ngIf="allData && allData['computer_report_file']">
                <a [href]="env+allData['computer_report_file']" target="_blank">
                  {{allData['computer_report_file']}}
                </a>
              </div>
              <div class="col-md-12 mb-3">
                <div class="form-group">
                  <label>Description</label>
                  <textarea 
                    name="" 
                    id="" 
                    rows="2" 
                    class="report__information form-control"
                    formControlName="computer_report_comment" 
                    [class.is-invalid]="isSubmitted && historyControls['computer_report_comment'].errors"
                  >
                  </textarea>
                  <div class="invalid-feedback">
                    <p>Description cannot be blank.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="report__btnGrp py-3">
          <button type="submit" class="btn btn__primary w-100">
            Submit
          </button>
        </div>
      </form>
    </div>
  </section>
  <!-- <section class="report__disclaimer my-5" *ngIf="!loading && allData.length">
    <div class="container">
      <div class="card bg-white shadow mb-5 border-0 col-12">
        <div class="card-body">
          <h3 class="border border-top-0 border-left-0 border-right-0 pb-3 font-weight-bold">
            Details
          </h3>
          <div class="pt-4">
            <div class="row">
              <ng-container *ngFor="let item of allData">
                <div class="col-12 col-sm-6 col-lg-3">
                  <div class="card pt-3">
                    <div class="container">
                      <div class="row">
                        <div class="col-4 col-sm-7 col-sm-7">
                          <ul class="list-unstyled">
                            <li>Title:</li>
                            <li>Uploaded At:</li>
                            <li>Description:</li>
                          </ul>
                        </div>
                        <div class="col-8 col-sm-5 col-5 p-0">
                          <ul class="list-unstyled">
                            <li class="">
                              {{item?.name}}
                            </li>
                            <li class="">
                              {{item?.created_at | date}}
                            </li>
                            <li class="">
                              {{item?.comment}}
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div class="report__btnGrp py-3 d-flex">
                        <a class="btn btn__primary mr-1 w-100" download target="_blank"
                          [href]="mediaUrl+item['history_file']">
                          Show File
                        </a>
                        <button type="button" class="btn btn__tertiary ml-1 w-100"
                          (click)="deleteCarReportHistory(item?.vehicle_history_uuid)">
                          Delete
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section> -->

  <p>&nbsp;</p>
</main>
<loader [active]="loading"></loader>
